import React from "react";
import { Link } from "react-router-dom";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import "./style.css";

const tools = [
  {
    title: "How to Add Shared Landmarks",
    description: "Step-by-step instructions for adding map pins (landmarks) that every resident sees on the rangefinder map.",
    icon: "📖",
    to: "/rangefinder/landmark-guide",
    color: "#2196F3",
  },
  {
    title: "Path Editor",
    description: "Draw and manage golf cart paths on the map. Define cart paths, streets, and mixed routes for the neighborhood.",
    icon: "✏️",
    to: "/rangefinder/path-editor",
    color: "#4CAF50",
  },
  {
    title: "Landmark Manager",
    description: "Create and manage navigable landmarks such as clubhouses, pools, gates, and other points of interest.",
    icon: "📍",
    to: "/rangefinder/landmark-manager",
    color: "#9C27B0",
  },
  {
    title: "Route Tester",
    description: "Test the routing engine by selecting start and end points to preview calculated routes and turn-by-turn directions.",
    icon: "🧭",
    to: "/rangefinder/route-tester",
    color: "#FF9800",
  },
];

const Rangefinder = () => {
  return (
    <DashboardLayout>
      <div className="rangefinder-container">
        <div className="rangefinder-header">
          <h2 className="rangefinder-title">Rangefinder</h2>
          <p className="rangefinder-subtitle">
            Manage golf cart navigation for the neighborhood — paths, landmarks, and routing.
          </p>
        </div>
        <div className="rangefinder-grid">
          {tools.map((tool) => (
            <Link key={tool.to} to={tool.to} className="rangefinder-card" style={{ borderTop: `4px solid ${tool.color}` }}>
              <div className="rangefinder-card-icon">{tool.icon}</div>
              <h3 className="rangefinder-card-title">{tool.title}</h3>
              <p className="rangefinder-card-desc">{tool.description}</p>
              <span className="rangefinder-card-link" style={{ color: tool.color }}>
                Open &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Rangefinder;
